const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: 'full', // full, close, compact, mobile,
    theme: 'gscNav', // View all valid theme colors inside MatxTheme/themeColors.js
    bgImgURL: '',
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'gscTopbar', // View all valid theme colors inside MatxTheme/themeColors.js
  },
};

export default Layout1Settings;
